import $ from 'jquery';

$('[data-collapse-child]').each(function () {
	const parent = $(this);
	const child = $(this).data('collapse-child');

	$(child).on('show.bs.collapse', function () {
		parent.addClass('is-active');
	});

	$(child).on('hide.bs.collapse', function () {
		parent.removeClass('is-active');
	});
});
